/**
 * Auto-load the next page of products when the Load more button scrolls into
 * view — the behaviour the theme's `infinity-scroll-active` class implies but
 * never implemented. That class is written by four Liquid sections
 * (main-collection, main-search, main-blog, main-list-collections) and read by
 * no JavaScript in the theme, so the setting alone leaves a manual button.
 *
 * Deliberately additive: this never modifies collection-load-more.js. It
 * watches the existing <collection-load-more> button and clicks it, so all the
 * real work — fetching, appending, history.replaceState, hiding on the last
 * page — stays in the theme's own custom element. If the theme is updated and
 * ships native infinite scroll, deleting this file is the whole rollback.
 */
(function () {
  "use strict";

  // Only opt-in grids. Without this the script would auto-load on every
  // collection, overriding merchants who deliberately chose a manual button.
  var GRID = ".infinity-scroll-active";
  var BUTTON = ".js-btn-load-more";

  // Start fetching before the button is visible so products are already there
  // by the time the shopper reaches the bottom.
  var ROOT_MARGIN = "600px";

  if (!("IntersectionObserver" in window)) return;

  function watch(grid) {
    if (grid.dataset.badgehqInfinite === "1") return;
    grid.dataset.badgehqInfinite = "1";

    var busy = false;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting || busy) return;

          var btn = entry.target;
          var host = btn.closest("collection-load-more");
          // The theme hides the host on the last page and disables the button
          // mid-fetch. Respecting both is what stops a runaway request loop.
          if (!host || host.classList.contains("hidden") || btn.disabled) return;

          busy = true;
          btn.click();

          // The element re-renders after each page; re-bind to whatever button
          // exists now. 800ms clears the theme's fetch + append.
          setTimeout(function () {
            busy = false;
            var next = document.querySelector(GRID + " " + BUTTON);
            if (next && next !== btn) {
              observer.unobserve(btn);
              observer.observe(next);
            }
          }, 800);
        });
      },
      { rootMargin: ROOT_MARGIN }
    );

    var btn = grid.querySelector(BUTTON);
    if (btn) observer.observe(btn);
  }

  function init() {
    document.querySelectorAll(GRID).forEach(watch);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  // Filtering and sorting swap the grid out via the Section Rendering API,
  // which leaves the old observer watching a detached button.
  document.addEventListener("shopify:section:load", init);
  new MutationObserver(init).observe(document.body, { childList: true, subtree: true });
})();
